import React, { useState } from 'react';
import { Select } from 'antd';

import { useCustomers } from '../../../hooks/data/useCustomers';
import { Customer } from '../../../hooks/data/models';
import { DateUpdateFlexRow } from '../../../components/widgets/DateUpdateFlexRow';


type CustomerSelectProps = {
  onChange?: (customer: Customer) => void;
}

export const CustomerSelect: React.FC<CustomerSelectProps> = ({
  onChange,
}) => {

  const {customers, isLoading, lastUpdated, refreshMainList} = useCustomers();
  const [selectedCustomerId, setSelectedCustomerId] = useState<string>();

  //Internal onChange handler to output the selected Customer
  const handleOnChange = (selectedId: string) => {
    setSelectedCustomerId(selectedId);
    if (onChange) {
      const selectedCustomer = customers.find(c => c._id === selectedId);
      if (selectedCustomer) {
        onChange(selectedCustomer);
      }
    }
  };

  return (
    <div>
      <DateUpdateFlexRow 
        lastUpdated={lastUpdated} 
        refreshCallback={refreshMainList}/>
      <Select
        showSearch
        placeholder="Choose a customer"
        optionFilterProp="children"
        value={selectedCustomerId}
        onChange={handleOnChange}
        loading={isLoading}
      >
        {customers.map(customer => (
          <Select.Option
            key={customer._id}
            value={customer._id}
          >
            {customer.firstName} {customer.lastName}, {customer.email} - Created: {customer.createdAt.substring(0, 10)}
          </Select.Option>
        ))}
      </Select>
    </div>
  );
}
